// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3bkaj","modalForm":"UpgradeEpcsModal_modalForm__2jNjF","modalFooter":"UpgradeEpcsModal_modalFooter__3qPSo"};